import React from 'react';
import PropTypes from 'prop-types';

import SvgIcon from '@components/svg-icon/svg-icon';

import { StandardDropdown, MessageBubble } from '@helpers/icon-dictionary';

import { Root, IconWrapper, Icon, NumberWrapper } from './styled';

const HelpIcon = (props) => {
  const { needAttentionStudentsCount } = props;

  if (needAttentionStudentsCount === 0) {
    return (
      <Icon>
        <SvgIcon icon={StandardDropdown} />
      </Icon>
    );
  }

  return (
    <Root>
      <IconWrapper>
        <SvgIcon icon={MessageBubble} />
        <NumberWrapper>{needAttentionStudentsCount}</NumberWrapper>
      </IconWrapper>
    </Root>
  );
};

HelpIcon.defaultProps = {
  needAttentionStudentsCount: 0
};

HelpIcon.propTypes = {
  needAttentionStudentsCount: PropTypes.number
};

export default React.memo(HelpIcon);



// WEBPACK FOOTER //
// ./components/learning-journey/help-icon/index.js